module.exports = __webpack_public_path__ + "static/media/blog-8.5ca2c915.svg";